import React, { useEffect } from 'react';
import { Flex } from 'antd';
import { useParams } from 'react-router-dom';

import {
    PromocodeFilters,
    PromocodeDTO,
} from '../service/promocodes.interface';
import { PromocodeTable } from '../components/PromocodeTable';
import { useFilters } from '../../products/hooks/useFilters';
import { initialFilters } from '../utils/fields';
import { useLazyReadPromocodesQuery } from '../service/promocode.api';
import { PromocodesActions } from '../components/PromocodesActions';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const PromocodesContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const {
        filters,
        get: fetchPromocodes,
        source,
        loading,
        updateFilters,
    } = useFilters<PromocodeFilters, PromocodeDTO>(
        useLazyReadPromocodesQuery,
        initialFilters
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            const payload = {
                shop_id: current.id,
                ...filters,
            };

            fetchPromocodes(payload, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, current.id]);

    return (
        <Flex vertical gap={16}>
            <PromocodesActions />

            <PromocodeTable
                filters={filters}
                updateFilters={updateFilters}
                source={source}
                loading={loading}
            />
        </Flex>
    );
};
